// Adds a branding-specific prefix to an image src path if applicable.
export default (imageSrc, customerBranding) => {
	if (!customerBranding) return imageSrc;

	// We expect imageSrc to start with a /
	return `/branding/${customerBranding}${imageSrc}`;
};
